module.exports = __webpack_public_path__ + "static/img/expired.c935361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insure/expired.png
// module id = MVx7
// module chunks = 1